import { CLEAR_ORDER } from './OrderActionTypes';

export const clearOrderAction = () => (dispatch: any) => {
  dispatch({ type: CLEAR_ORDER });
};
